import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { findDOMNode } from 'react-dom';
var ResizeObserverComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ResizeObserverComponent, _React$Component);
  var _super = _createSuper(ResizeObserverComponent);
  function ResizeObserverComponent() {
    var _this;
    _classCallCheck(this, ResizeObserverComponent);
    _this = _super.apply(this, arguments);
    _this.componentWillUnmount = function () {
      if (_this.resizeObserver) {
        _this.destroyResizeObserver();
      }
    };
    _this.createResizeObserver = function () {
      _this.resizeObserver = new ResizeObserver(function (entry) {
        var onResize = _this.props.onResize;
        onResize && onResize(entry);
      });
      // eslint-disable-next-line react/no-find-dom-node
      _this.resizeObserver.observe(findDOMNode(_assertThisInitialized(_this)));
    };
    _this.destroyResizeObserver = function () {
      _this.resizeObserver && _this.resizeObserver.disconnect();
      _this.resizeObserver = null;
    };
    return _this;
  }
  _createClass(ResizeObserverComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (! /*#__PURE__*/React.isValidElement(this.props.children)) {
        console.warn('The children of ResizeObserver is invalid.');
      } else {
        this.createResizeObserver();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // eslint-disable-next-line react/no-find-dom-node
      if (!this.resizeObserver && findDOMNode(this)) {
        this.createResizeObserver();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return ResizeObserverComponent;
}(React.Component);
export default ResizeObserverComponent;